/**
 * 浮动的水平居中布局
 */
BI.FloatHorizontalLayout = function () {
};
BI.shortcut("bi.horizontal_float", BI.FloatHorizontalLayout);
